import _functionCall from "../internals/function-call";
import _anObject from "../internals/an-object";
import _getIteratorDirect from "../internals/get-iterator-direct";
import _getIteratorMethod from "../internals/get-iterator-method";
var exports = {};
var call = _functionCall;
var anObject = _anObject;
var getIteratorDirect = _getIteratorDirect;
var getIteratorMethod = _getIteratorMethod;
exports = function (obj, stringHandling) {
  if (!stringHandling || typeof obj !== "string") anObject(obj);
  var method = getIteratorMethod(obj);
  return getIteratorDirect(anObject(method !== undefined ? call(method, obj) : obj));
};
export default exports;